(function ($) {
  Drupal.behaviors.stickyAddToBagV1 = {
    attach: function (context, settings) {
      var $stickyAddToBag = $('.device-pc .sticky-add-to-bag', context);
      var $header = $('#header', context);

      // Sticky Add To Bag
      $(window).on('scroll', _.throttle(function () {
        if ($(window).scrollTop() >= $header.height()) {
          $stickyAddToBag.removeClass('hidden');
        } else {
          $stickyAddToBag.addClass('hidden');
        }
      }, 100));
    }
  };
})(jQuery);
